import { render, staticRenderFns } from "./BlogListSide.vue?vue&type=template&id=2c2e4e9e&scoped=true"
import script from "./BlogListSide.vue?vue&type=script&lang=js"
export * from "./BlogListSide.vue?vue&type=script&lang=js"
import style0 from "./BlogListSide.vue?vue&type=style&index=0&id=2c2e4e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e4e9e",
  null
  
)

export default component.exports